import React from 'react';
import { FC, useEffect, useState, useRef } from "react"
import TriangleIconForIpr from './triangleIconForIpr';
import { Box, Stack, IconButton, Grid, Input, Typography, Button, Paper, experimentalStyled as styled, Hidden } from "@mui/material";
import TriangleIcon from './triangleIcon';
import StageAddIcon from './stageAddIcon';
import IprIcon from './iprIcon';
import { useAppDispatch, useAppSelector } from "../../../core/app/hooks"
import { RootState } from "../../../core/app/store"
import IprIcon2 from './IprIcon2';

const StageFoldItemForIpr = (props) => {

  const topAreaHeight = 12
  const addMargin = 3
  const triangleMargin = 2
  const triangleHeight = 5

  const redColor = "#FF5E63"
  const curStageArchQuick3Index = (props.archType === 0 ? props.upQuick3Index : props.downQuick3Index)
  const isIprNode = props.isNodeContains(props.item.nodeTypes, 1)
  const firstCollisionStage = props.firstCollisionStage//(props.archType === 0 ? props.upIprWaringIndex : props.downIprWaringIndex)

  return (
    <div style={{
      width: props.actualStageWidth,
      height: (topAreaHeight + addMargin + props.singleStageHeight + triangleMargin + triangleHeight),
      position: "relative",
      // backgroundColor: "red"
    }}
    onClick={() => props.stageButtonClickHandle(props.item, props.index, props.itemArray)}>

      {/* {props.archType === 1 ? <TriangleIcon position={"absolute"} left={props.actualStageWidth/2} top={0} direction="down" visibility={props.index === props.stageCurrentStep ? "" : "hidden"} /> : <></>}
      {props.archType === 0 ? <StageAddIcon position={"absolute"} left={props.actualStageWidth/2-1} top={0}  status={props.uiShowType === "passive_aligner" ? (props.isNodeContains(props.item.nodeTypes, 14) ? "del" : "add") : (props.isNodeContains(props.item.nodeTypes, 14) ? "" : (props.isNodeContains(props.item.nodeTypes, 0) ? "del" : "add"))} visibility={(props.viewEdit && props.index > curStageArchQuick3Index && props.index === props.stageCurrentStep) ? "" : "hidden"} onClick={props.addNodeHandler}/> : <></>} */}

      {props.archType === 1 ? <TriangleIconForIpr zIndex={2} position={"absolute"} left={props.actualStageWidth} top={4} direction="down" visibility={props.index === props.stageCurrentStep ? "" : "hidden"} /> : <></>}
      
      {props.archType === 0 && !isIprNode && props.viewEdit && props.index >= curStageArchQuick3Index && props.index === props.stageCurrentStep? <StageAddIcon zIndex={2} position={"absolute"} left={props.actualStageWidth} top={0} status={"add"} onClick={props.addNodeHandler} /> : <></>}
      {props.archType === 0 && isIprNode && props.viewEdit && props.index >= curStageArchQuick3Index && props.index === props.stageCurrentStep? <StageAddIcon zIndex={2} position={"absolute"} left={props.actualStageWidth+16} top={1} status={"del"} onClick={props.deleteNodeHandler}/> : <></>}
      {props.archType === 0 && (isIprNode || props.iprDragFromStep === props.index || props.iprDragToStep === props.index) && props.viewEdit? <IprIcon2 opacity={(props.iprDragFromStep !== -1 && props.iprDragFromStep === props.index && props.iprDragToStep !== props.index) ? 0.01 : 1.0} zIndex={2} position={"absolute"} left={props.actualStageWidth-3} top={0} direction="down" index={props.index} iprPositionXChanged={props.iprPositionXChanged} iprDragStoped={props.iprDragStoped}/> : <></>}

      <div style={{
        width: props.actualStageWidth,
        height: "1px",
        position: "absolute",
        left: "0px",
        top: props.archType === 0 ? (topAreaHeight + addMargin + props.singleStageHeight / 2 - props.scaleHeight/2) : (triangleHeight + triangleMargin + props.singleStageHeight / 2 + props.scaleHeight/2),
        backgroundColor: firstCollisionStage[props.index] === 1 ? redColor : (props.index <= curStageArchQuick3Index ? "#c1c1c1" : "#818181"),
      }}>
      </div>

      <div style={{
        width: "1px",
        height: props.scaleHeight,
        position: "absolute",
        left: props.actualStageWidth / 2 - 1,
        top: props.archType === 0 ? (topAreaHeight + addMargin + props.singleStageHeight / 2 - props.scaleHeight/2 + 1) : (triangleHeight + triangleMargin + props.singleStageHeight / 2 + props.scaleHeight/2 - props.scaleHeight),
        backgroundColor: props.index === props.stageCurrentStep ? "transparent" : (firstCollisionStage[props.index] === 1 ? redColor : (props.index <= curStageArchQuick3Index ? "#c1c1c1" : "#818181")),
      }}>
      </div>

      <div style={{
        width: props.actualStageWidth - 2*2,
        height: props.singleStageHeight,
        // border: "1px solid transparent",
        position: "absolute",
        left: "2px",
        top: props.archType === 0 ? (topAreaHeight + addMargin) : (triangleHeight + triangleMargin),
        borderRadius: "4px",
        backgroundColor: "transparent", //props.index === props.stageCurrentStep ? "#02AFEC" : "transparent",
      }}>

        <Box sx={{
          width: 6,
          height: 6,
          backgroundColor: props.isNodeContains(props.item.nodeTypes, 0) ? "#FF6363" : "transparent",//props.isNodeContains(props.item.nodeTypes, 0) ? (props.stageCurrentStep === props.index ? "white" : "#02AFEC") : "transparent",
          borderRadius: 3,
          margin: '0 auto',
          position: "absolute",
          left: (props.actualStageWidth - 2*2) / 2 - (6 / 2) - 1,
          top: props.archType === 0 ? 3 : (props.singleStageHeight - 3 - 6)
        }}>
        </Box>

        <div style={{ 
          // color: props.isNodeContains(props.item.nodeTypes, 14) ? (props.stageCurrentStep === props.index ? "white" : "#02AFEC") : "transparent",
          color: props.isNodeContains(props.item.nodeTypes, 14) ? ("#FF6363") : "transparent",
          userSelect: "none",
          width: 6, 
          height: 12,
          position: "absolute",
          left: (props.actualStageWidth - 2*2) / 2 - (6 / 2),
          top: props.archType === 0 ? 0 : (props.singleStageHeight - 9),
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          fontSize: 12 }}>
            P
        </div>

        <span style={{
          userSelect: "none",
          width: props.actualStageWidth - 2*2, 
          height: 16, 
          fontSize: 15,
          position: "absolute",
          left: 0,
          bottom: props.archType === 0 ? -2 : (props.singleStageHeight - 2 - 16),
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          color: props.stageCurrentStep === props.index ? (firstCollisionStage[props.index] === 1 ? redColor : "black") : "transparent",
          zIndex: 0,
          // backgroundColor: "gray"
        }}>{props.item.indexStr}</span>

      </div>

      {/* {props.archType === 0 ? <TriangleIcon position={"absolute"} left={props.actualStageWidth/2} top={topAreaHeight + addMargin + props.singleStageHeight + triangleMargin} direction="up" visibility={props.index === props.stageCurrentStep ? "" : "hidden"} /> : <></>}
      {props.archType === 1 ? <StageAddIcon position={"absolute"} left={props.actualStageWidth/2-1} top={triangleHeight + addMargin + props.singleStageHeight + triangleMargin}  status={props.uiShowType === "passive_aligner" ? (props.isNodeContains(props.item.nodeTypes, 14) ? "del" : "add") : (props.isNodeContains(props.item.nodeTypes, 14) ? "" : (props.isNodeContains(props.item.nodeTypes, 0) ? "del" : "add"))} visibility={(props.viewEdit && props.index > curStageArchQuick3Index && props.index === props.stageCurrentStep) ? "" : "hidden"} onClick={props.addNodeHandler}/> : <></>} */}
      {props.archType === 0 ? <TriangleIconForIpr zIndex={2} position={"absolute"} left={props.actualStageWidth} top={topAreaHeight + addMargin + props.singleStageHeight + triangleMargin - 3} direction="up" visibility={props.index === props.stageCurrentStep ? "" : "hidden"} /> : <></>}
          
      {props.archType === 1 && !isIprNode && props.viewEdit && props.index >= curStageArchQuick3Index && props.index === props.stageCurrentStep? <StageAddIcon zIndex={2} position={"absolute"} left={props.actualStageWidth} top={triangleHeight + addMargin + props.singleStageHeight + triangleMargin} status={"add"} onClick={props.addNodeHandler} /> : <></>}
      {props.archType === 1 && (isIprNode || props.iprDragFromStep === props.index || props.iprDragToStep === props.index) && props.viewEdit? <IprIcon2 opacity={(props.iprDragFromStep !== -1 && props.iprDragFromStep === props.index && props.iprDragToStep !== props.index) ? 0.01 : 1.0} zIndex={2} position={"absolute"} left={props.actualStageWidth-3} top={triangleHeight + addMargin + props.singleStageHeight + triangleMargin-3} direction="up" index={props.index} iprPositionXChanged={props.iprPositionXChanged} iprDragStoped={props.iprDragStoped}/> : <></>}
      {props.archType === 1 && isIprNode && props.viewEdit && props.index >= curStageArchQuick3Index && props.index === props.stageCurrentStep? <StageAddIcon zIndex={2} position={"absolute"} left={props.actualStageWidth+2+14} top={triangleHeight + addMargin + props.singleStageHeight + triangleMargin} status={"del"} onClick={props.deleteNodeHandler}/> : <></>}

      {/* {props.archType === 0 ? <IprIcon visibility={isIprNode ? "" : "hidden"} position={"relative"} left={props.actualStageWidth} top={topAreaHeight + addMargin - 5} direction="up"/> : <IprIcon visibility={isIprNode ? "" : "hidden"} position={"relative"} left={props.actualStageWidth} top={triangleHeight + addMargin} direction="down"/>} */}
      
    </div>
  );
};
 
export default StageFoldItemForIpr;